export const DEFAULT_SPACING = '2rem';
